// Tailwind "prose" recipe for rendered Markdown. Shared by the public news
// piece and the admin Markdown editor preview so the two render identically.
export const proseClasses = [
  '[&_h2]:font-headline [&_h2]:font-semibold [&_h2]:text-xl [&_h2]:text-on-surface [&_h2]:mt-8 [&_h2]:mb-3',
  '[&_h3]:font-headline [&_h3]:font-semibold [&_h3]:text-base [&_h3]:text-on-surface [&_h3]:mt-6 [&_h3]:mb-2',
  '[&_p]:text-on-surface-light [&_p]:leading-relaxed [&_p]:mb-4',
  '[&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-4',
  '[&_li]:text-on-surface-light [&_li]:mb-1 [&_li]:leading-relaxed',
  '[&_strong]:text-on-surface [&_strong]:font-semibold',
  '[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2',
  '[&_hr]:border-line [&_hr]:my-6',
  '[&_blockquote]:border-l-[3px] [&_blockquote]:border-primary/35 [&_blockquote]:bg-primary/[0.05] [&_blockquote]:rounded-r-md [&_blockquote]:px-5 [&_blockquote]:py-4 [&_blockquote]:my-5',
  '[&_blockquote_p]:text-on-surface-light [&_blockquote_p]:mb-0 [&_blockquote_strong]:text-primary',
].join(' ');
